import axios from 'axios'
import store from '../redux/store'
import {isExpired, decodeToken} from 'react-jwt'
import * as authHelper from '../app/modules/auth/core/AuthHelpers'
import {MarvelToast} from '../app/helper/MarvelToast'

const ignoreTokenCheckUrls = ['/auth/login', 'authentication/forgot-password']

const API_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_DEVELOPMENT_URL : process.env.REACT_APP_API_PRODUCTION_URL
const TIMEOUT = process.env.REACT_APP_TIMEOUT
const instance = axios.create({
  baseURL: API_URL,
  timeout: TIMEOUT, // timeout dalam milidetik
})

instance.interceptors.request.use(
  async function (config) {
    const {
      auth: {authToken},
    } = store.getState()
    var _token = authToken

    config.headers['Content-Type'] = 'application/json'
    if (config.data && config.data['params']) {
      config.params = config.data['params']
    }

    if (ignoreTokenCheckUrls.includes(config.url)) {
      return config
    }

    if (!decodeToken(_token)) {
      await logout()
    }

    if (isExpired(_token)) {
      //   await refreshToken(_token).then(async (result) => {
      //     if (result.success) {
      //       _token = result.data
      //       config.headers['Authorization'] = 'Bearer ' + result.data
      //     } else {
      await logout()
      //     }
      //   })
    } else {
      config.headers['Authorization'] = 'Bearer ' + _token
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log('error', error)

    // Menangani timeout
    if (error.code === 'ECONNABORTED' || error.response?.status === 408) {
      return Promise.reject(error)
    }

    switch (error.response.status) {
      case 401:
        logout()
        break
      case 404:
        MarvelToast.error(error?.response?.data?.message ?? error?.message ?? 'Endpoint could not be found.')
        break
      default:
        MarvelToast.error(error?.response?.data?.message ?? error?.message ?? error?.response?.status.toSring())
        break
    }
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data)
    }
  }
)

// const refreshToken = async (token) => {
//   return new Promise((resolve) => {
//     fetch(`${API_URL}authentication/refresh-token`, {
//       method: 'POST',
//       // mode: 'cors',
//       // cache: 'no-cache',
//       // credentials: 'same-origin',
//       headers: {
//         'Content-Type': 'application/json',
//         Device: 'device',
//         Authorization: 'Bearer ' + token,
//       },
//     })
//       .then((res) => res.json())
//       .then(async (res) => {
//         const {success, data} = res
//         if (success) {
//           store.dispatch(actions.setToken(data))
//         }
//         resolve(res)
//       })
//       .catch(async (e) => {
//         await logout()
//         window.location.reload()
//       })
//   })
// }

const logout = async () => {
  authHelper.logout()
}

export default instance
